import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from '../../../_virtual/_rollupPluginBabelHelpers.mjs';
import React from 'react';
import { hsbToHex } from '@shopify/polaris';
import styles from '../TextColor.scss.mjs';
import { memoize } from 'lodash-decorators';

var _dec, _dec2, _class;
var Key = /*#__PURE__*/function (Key) {
  Key[Key["Enter"] = 13] = "Enter";
  Key[Key["Space"] = 32] = "Space";
  return Key;
}(Key || {});
let Presets = (_dec = memoize(), _dec2 = memoize(), (_class = class Presets extends React.PureComponent {
  render() {
    const {
      colors
    } = this.props;
    const presetsMarkup = colors.map(({
      name,
      hue,
      saturation,
      brightness
    }) => {
      const color = {
        hue,
        saturation,
        brightness
      };
      const hexColor = hsbToHex(color);
      return /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: styles.Preset,
        onClick: this.handleClick(color),
        onKeyDown: this.handleKeyDown(color),
        style: {
          backgroundColor: hexColor
        },
        "aria-label": name,
        key: hexColor
      });
    });
    return /*#__PURE__*/React.createElement("div", {
      className: styles.Row
    }, presetsMarkup);
  }
  handleClick(color) {
    return () => {
      const {
        onPresetClick
      } = this.props;
      onPresetClick(color);
    };
  }
  handleKeyDown(color) {
    return event => {
      const {
        onPresetClick,
        onPresetKeyDown
      } = this.props;
      if (event.keyCode === Key.Enter || event.keyCode === Key.Space) {
        onPresetClick(color);
        onPresetKeyDown();
      }
    };
  }
}, (_applyDecoratedDescriptor(_class.prototype, "handleClick", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "handleClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeyDown", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeyDown"), _class.prototype)), _class));
var Presets$1 = Presets;

export { Presets$1 as default };
